import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, ClipboardList, Phone } from "lucide-react";
import { useCart } from "../context/CartContext";
import { COMPANY } from "../data/site";

const links = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About Us" },
    { to: "/catalog", label: "Products" },
    { to: "/brands", label: "Brands" },
    { to: "/faq", label: "FAQ" },
    { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    const { count } = useCart();
    const navigate = useNavigate();

    return (
        <header className="sticky top-0 z-50 bg-background/90 backdrop-blur-xl border-b border-border" data-testid="navbar">
            <div className="bg-primary text-primary-foreground text-xs">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex items-center justify-between py-2">
                    <span className="tracking-[0.15em] uppercase font-medium hidden sm:block">
                        Import • Export • Wholesale Distribution
                    </span>
                    <a href={`tel:${COMPANY.phones[0]}`} className="flex items-center gap-2 hover:text-secondary transition-colors" data-testid="topbar-phone">
                        <Phone size={13} /> {COMPANY.phones[0]}
                    </a>
                </div>
            </div>
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-20">
                    <Link to="/" className="flex items-center gap-3 group" data-testid="logo-link">
                        <div className="leading-none">
                            <div className="font-heading font-black text-2xl tracking-tight">YATTO LLC</div>
                            <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">{COMPANY.tagline}</div>
                        </div>
                    </Link>

                    <nav className="hidden lg:flex items-center gap-7">
                        {links.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                                className={({ isActive }) =>
                                    `text-sm font-medium tracking-wide transition-colors hover:text-primary ${
                                        isActive ? "text-primary" : "text-foreground/70"
                                    }`
                                }
                            >
                                {l.label}
                            </NavLink>
                        ))}
                    </nav>

                    <div className="flex items-center gap-3">
                        <button
                            onClick={() => navigate("/order")}
                            data-testid="cart-button"
                            className="relative flex items-center gap-2 bg-primary text-primary-foreground px-4 py-2.5 text-sm font-semibold hover:bg-secondary hover:text-secondary-foreground transition-colors"
                        >
                            <ClipboardList size={17} />
                            <span className="hidden sm:inline">Order Request</span>
                            {count > 0 && (
                                <span className="absolute -top-2 -right-2 bg-secondary text-secondary-foreground text-[11px] w-5 h-5 flex items-center justify-center font-bold" data-testid="cart-count">
                                    {count}
                                </span>
                            )}
                        </button>
                        <button className="lg:hidden p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
                            {open ? <X /> : <Menu />}
                        </button>
                    </div>
                </div>
            </div>

            {open && (
                <nav className="lg:hidden border-t border-border bg-background" data-testid="mobile-menu">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            onClick={() => setOpen(false)}
                            className={({ isActive }) =>
                                `block px-6 py-4 text-sm font-medium border-b border-border ${isActive ? "text-primary bg-muted" : ""}`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>
            )}
        </header>
    );
};
